import ActivityIntegrationMixin from '@/mixins/vue/ActivityIntegrationMixin';
import BalanceIntegrationMixin from '@/mixins/vue/BalanceIntegrationMixin';
import PhotoIntegrationMixin from '@/mixins/vue/PhotoIntegrationMixin';
import ProductIntegrationMixin from '@/mixins/vue/ProductIntegrationMixin';
// mixin.js
import TemplateIntegrationMixin from '@/mixins/vue/TemplateIntegrationMixin';
import { Component, Mixins } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class HomeMixin extends Mixins(
    TemplateIntegrationMixin,
    PhotoIntegrationMixin,
    ActivityIntegrationMixin,
    ProductIntegrationMixin,
    BalanceIntegrationMixin,
) {}
